import React, { useEffect } from "react";
import { Form, FormInstance } from "antd";
import { IDocumentList, IEditProcess } from "store/process/process-model";
import FormNewEntry from "./form";

interface IEditProcessProps {
  editProcess: IEditProcess;
  visibleDrawerEditProcess: boolean;
  documentsList: Array<IDocumentList>;
  form: FormInstance;
  eventInboundActive: boolean;
  eventOutboundActive: boolean;
  visibleDocuments: boolean;
  allowImageCapture: boolean;
}
interface IDispatchProps {
  isLoading?: boolean;
  processFetchDocumentsAsync?: (...args) => void;
  processUpdateFormModified: (...args) => void;
  processEventInboundActive: (...args) => void;
  processEventOutboundActive: (...args) => void;
  processUpdateVisibleDocuments: (...args) => void;
  processImageCapturesActive: (...args) => void;
}

export type propsEditForm = IEditProcessProps & IDispatchProps;

const EditForm = ({
  form,
  documentsList,
  processFetchDocumentsAsync,
  editProcess,
  visibleDrawerEditProcess,
  processUpdateFormModified,
  eventInboundActive,
  eventOutboundActive,
  processEventInboundActive,
  processEventOutboundActive,
  processUpdateVisibleDocuments,
  processImageCapturesActive,
  visibleDocuments,
  allowImageCapture,
}: propsEditForm) => {
  useEffect(() => {
    if (editProcess?.id) {
      form.setFieldsValue(editProcess);
      editProcess.documents?.length > 0 && processUpdateVisibleDocuments(true);
    }
  }, [editProcess]);

  return (
    <Form.Provider
      onFormChange={(_, info) => {
        const { changedFields } = info;
        const changedFileldsSize = changedFields?.length || 0;
        if (changedFileldsSize === 1) {
          processUpdateFormModified(true);
        }
      }}
    >
      <FormNewEntry
        form={form}
        documentsList={documentsList}
        visibleDrawerNewProcess={false}
        processFetchDocumentsAsync={processFetchDocumentsAsync}
        visibleDrawerEditProcess={visibleDrawerEditProcess}
        eventInboundActive={eventInboundActive}
        eventOutboundActive={eventOutboundActive}
        processEventInboundActive={processEventInboundActive}
        processEventOutboundActive={processEventOutboundActive}
        processUpdateVisibleDocuments={processUpdateVisibleDocuments}
        visibleDocuments={visibleDocuments}
        allowImageCapture={allowImageCapture}
        processImageCapturesActive={processImageCapturesActive}
      />
    </Form.Provider>
  );
};

export default EditForm;
